/* global WEBSOCKET_URL */
import { FC } from 'react';
// import { FC, useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
// import { Outlet, useNavigate } from 'react-router-dom';
import { CommunicationsCenter } from '@components/CommunicationsCenter/CommunicationsCenter';
import { AnnouncementCardList } from '@components/CommunicationsCenter/AnnouncementCardList';
import { NotificationCenterV2 } from '@components/interface/NotificationCenterV2';
import { StatusBottomBar } from '@components/interface/StatusBottomBar';
import { StatusBottomBarMobile } from '@components/interface/StatusBottomBarMobile';
import { NotificationProvider } from '@context/NotificationsContext';
import { PushNotificationProvider } from '@context/PushNotificationContext';
import { WebSocketProvider } from '@context/WebSocketContext';
import { useGetCommerce } from '@pages/Commerce/hooks/commerce';
import { SubscriptionStatusBar } from '@pages/Subscriptionsv2/components/SubscriptionStatusBar';
import { useInitSubscriptionDetails, useSubscription } from '@pages/Subscriptionsv2/hooks/useSubscriptions';
import { ModuleName } from '@utils/constants';
import { useChangeDeliveryStatus } from '@utils/hooks/useChangeDeliveryStatus';
import { useChangeOrderStatus } from '@utils/hooks/useChangeOrderStatus';
import { useChangePaymentStatus } from '@utils/hooks/useChangePaymentStatus';
import { useDesktop } from '@utils/hooks/useDesktop';
import { useIncomingOrder } from '@utils/hooks/useIncomingOrder';
import { useInitElectronPrinters } from '@utils/hooks/useInitElectronPrinters';
import { useInitElectronVersion } from '@utils/hooks/useInitElectronVersion';
import useModules from '@utils/hooks/useModules';
import { useRiderAssigned } from '@utils/hooks/useRiderAssigned';
import { useSimulateClick } from '@utils/hooks/useSimulateClick';
import NavBar from './NavBar/NavBar';
import Header from './header/Header';
import HeaderV3 from './header/HeaderV3';
import { NotificationPermissionRequest } from '@components/NotificationPermissionRequest';
import { PwaInstallPrompt } from '@components/PwaInstallPrompt';
import { useActiveUserSocket } from '@hooks/useActiveUserSocket';
import { useScheduledOrdersSocket } from '@utils/hooks/useScheduledOrdersSocket';

const PrivateGlobalHooks = () => {
  useInitSubscriptionDetails();
  useIncomingOrder();
  useRiderAssigned();
  useChangeOrderStatus();
  useChangePaymentStatus();
  useSimulateClick();
  useInitElectronPrinters();
  useInitElectronVersion();
  useChangeDeliveryStatus();
  useScheduledOrdersSocket();
  return null;
};

const Layout: FC = () => {
  const isDesktop = useDesktop();
  useActiveUserSocket();
  const { commerce } = useGetCommerce();
  const { hasModule } = useModules();
  const { isFreemium, isTrial, accountId } = useSubscription();

  return (
    <WebSocketProvider
      url={WEBSOCKET_URL}
      accountId={accountId}
      commerceId={commerce?.id}
      allowConnection={hasModule(ModuleName.HISTORIAL) || false}
    >
      <NotificationProvider>
        <PushNotificationProvider>
          <PrivateGlobalHooks />
          <main className="w-screen h-screen flex flex-col">
            {isDesktop ? <Header /> : <HeaderV3 />}
            <div className="flex flex-1 flex-col-reverse lg:flex-row overflow-hidden pt-16 lg:pt-14 pb-[62.14px] lg:pb-0">
              <NavBar />

              {(isFreemium || isTrial) && !isDesktop && <SubscriptionStatusBar isMobile />}
              {!isDesktop && <StatusBottomBarMobile />}
              <div className="relative flex-1 flex flex-col min-w-0 overflow-auto">
                <AnnouncementCardList />
                <Outlet />
              </div>
            </div>
            {isDesktop && <StatusBottomBar />}
            {(isFreemium || isTrial) && isDesktop && <SubscriptionStatusBar />}
          </main>
          <NotificationCenterV2 />
          <CommunicationsCenter />
          <NotificationPermissionRequest />
          <PwaInstallPrompt />
        </PushNotificationProvider>
      </NotificationProvider>
    </WebSocketProvider>
  );
};

export default Layout;
